import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "availability_days",
    object: "availability_day",
    header: [
      { text: "Day", value: "day" },
      { text: "Is Available", value: "is_available" },
      { text: "Hours", value: "availability_hour"},
      { text: "Acciones", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
